module.exports = __webpack_public_path__ + "media/images/ui__infoBox-99807c92204bfd4bc89310b2bb176521.png";